import React from 'react'
import { Row, Col } from "react-bootstrap";



export default class DetailElementBiografie extends React.Component {

	render() {
		return (<div>
			{this.props.value ?
				<div>
					<Row >
						<Col style={{ backgroundColor: '#ffffff' }}>
							<strong>{this.props.name}</strong>
						</Col>
						<Col md="auto" style={{ backgroundColor: '#ffffff' }}></Col>
						<Col md={{ span: 11, offset: 1 }} style={{ backgroundColor: '#fbfbfb' }}>
							{this.props.children ? this.props.children : this.props.value}
						</Col>
					</Row>
					{this.props.rights ?
					<Row >
						<Col md="auto" style={{ backgroundColor: '#ffffff' }}></Col>
						<Col md={{ span: 11, offset: 1 }} style={{ backgroundColor: '#fbfbfb' }}>
						{this.props.rights? this.props.rights.map((entry, id)=>( entry.reference === "biografie"?<div key={id}>{entry.rightChoices.map((right)=>(<div key={entry.id}><strong>Autor: </strong>{right.value}{right.comment?" | "+right.comment:""}</div>))}</div>:"" )):""}
						</Col>
					</Row>
					: ""}
				</div>
				: ""}</div>

		)
	}
}





